export const API_URL = "https://plantsbolivia.com/api";
//export const API_URL = "http://localhost:4000/api";

export const APP_EXPO = "https://plantsbolivia.com/#";

export const createHeader = (token) => {
  const headers = { headers: { "x-access-token": token } };
  return headers;
};
